import { render } from "./DynvibeDynamicNew.vue?vue&type=template&id=ee9dc14c&scoped=true"
import script from "./DynvibeDynamicNew.vue?vue&type=script&lang=js"
export * from "./DynvibeDynamicNew.vue?vue&type=script&lang=js"

import "./DynvibeDynamicNew.vue?vue&type=style&index=0&id=ee9dc14c&scoped=true&lang=css"

import exportComponent from "/Users/hamzaassif/Work/detect-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee9dc14c"]])

export default __exports__